import moment from 'moment';

export const DateRangeOptions = [
  {
    label: 'Last Month',
    value: [
      moment()
        .subtract(1, 'months')
        .startOf('month')
        .toDate(),
      moment()
        .subtract(1, 'months')
        .endOf('month')
        .toDate()
    ]
  },
  {
    label: 'This Month',
    value: [
      moment()
        .startOf('month')
        .toDate(),
      moment()
        .endOf('month')
        .toDate()
    ]
  },
  {
    label: 'Calendar Year',
    value: [
      moment()
        .startOf('year')
        .toDate(),
      moment()
        .endOf('year')
        .toDate()
    ]
  }
];

export const GroupByOptions = [
  {
    value: 'picklistId',
    label: 'Picklist',
    type: 'groupBy'
  },
  {
    value: 'clientId',
    label: 'Guest',
    type: 'groupBy'
  },
  {
    value: 'trackingMethodId',
    label: 'Tracking Method',
    type: 'groupBy'
  },
  {
    value: 'status',
    label: 'Reservation status',
    type: 'groupBy'
  }
];
